import Hero from "../components/Hero";
import OfficeBearers from "../components/OfficeBearers";

import ObDetails from "../utils/ObDetails";
import OsDetails from "../utils/OsDetails";
import JsDetails from "../utils/JsDetails";

import eceaLogo from "../assets/logo/ecea-logo.png";

export default function Home() {
  return (
    <>
      {/* HERO */}
      <Hero />

      
      {/* TEAM */}
      <section id="team" className="scroll-mt-40">
        <OfficeBearers ObDetails={ObDetails} title="Office Bearers" />
        <OfficeBearers ObDetails={OsDetails} title="Organising Secretaries" />
        <OfficeBearers ObDetails={JsDetails} title="Joint Secretaries" />
      </section>

      {/* CONTACT */}
<section
  id="contact"
  className="scroll-mt-40 bg-[#0b1220] text-white py-28"
>
  <div className="max-w-6xl mx-auto px-6">
    <div className="rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 p-12">

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">

        {/* ECEA LOGO */}
        <div className="flex items-center justify-center">

          <div className="relative flex items-center justify-center">

            {/* Gold Glow */}
            <div className="absolute w-60 h-60 bg-yellow-400/25 blur-3xl rounded-full"></div>

            {/* Logo */}
            <img
              src={eceaLogo}
              alt="ECEA Logo"
              className="relative w-48 object-contain"
            />

          </div>

        </div>

        {/* CONTENT */}
        <div className="md:col-span-2 space-y-6">

          <h2 className="text-3xl font-semibold">
            Electronics and Communication Engineering Association
          </h2>

          <p className="text-lg text-white/80 leading-relaxed">
            The Electronics and Communication Engineers’ Association (ECEA)
            is a student-run organization that has been functioning for nearly
            three decades to support the academic and professional growth
            of students.
          </p>

          <p className="text-lg text-white/80 leading-relaxed">
            ECEA organizes technical events, workshops, symposiums, and
            activities that encourage innovation, teamwork, and leadership
            among students.
          </p>

          {/* EMAIL */}
          <p className="text-base text-white/80">
            <span className="font-medium text-white">Email:</span>{" "}
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=eceaobs26@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              eceaobs26@gmail.com
            </a>
          </p>

          {/* ADDRESS */}
          <p className="text-base text-white/80 leading-relaxed">
            <span className="font-medium text-white">Address:</span>
            <br />
            Department of Electronics and Communication Engineering
            <br />
            Anna University (CEG Campus)
            <br />
            Chennai – 600025
          </p>

        </div>
      </div>

      {/* GOOGLE MAP */}
      <div className="mt-10 rounded-xl overflow-hidden border border-white/20">
        <iframe
          title="ECEA Location"
          src="https://maps.google.com/maps?q=Department%20of%20Electronics%20and%20Communication%20Engineering%20Anna%20University&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-[260px]"
          loading="lazy"
        />
      </div>

    </div>
  </div>
</section>
    </>
  );
}


